import type { IGetProfileResponse } from '~/shared/api/magnit-id/user/models';
import type { IMarketCustomerResponse } from '@/shared/api';
import type { IUserStoreMarketCustomer } from '../models';
import { UserMM } from '~/entities/user/business/UserMM';

export function mapUser(user: IGetProfileResponse): UserMM {
  return new UserMM({
    id: user.userId,
    birthDate: user.birthDate,
    email: user.email,
    firstName: user.firstName,
    phone: user.phone,
    sex: user.gender,
  });
}

export function mapMarketCustomer(
  marketCustomerFromApi: IMarketCustomerResponse
): IUserStoreMarketCustomer {
  return {
    customerId: marketCustomerFromApi.customerId.toString(),
    accountId: marketCustomerFromApi.accountId.toString(),
  };
}
